import { CircularProgress } from '@mui/joy'

export default () => (
    <CircularProgress
        size="sm"
        sx={{ '--CircularProgress-size': '20px' }}
    />
)
